import { firebase, _firestore } from '@/lib/db';

export default async ( commentSectionRef, comment, sectionId, replyComment ) => {
	const commentsRef = commentSectionRef.collection( 'comments' );

	// console.log( comment );

	commentSectionRef.update( {
		commentCount : firebase.firestore.FieldValue.increment( 1 )
	} );


	const { replyingTo } = comment;

	if ( replyingTo !== 'root' ) {
		commentsRef.doc( replyingTo ).update( {
			commentCount : firebase.firestore.FieldValue.increment( 1 )
		} );
	}

	const commentId = await commentsRef.add( comment )
		.then( ( ref ) => {
			const { id } = ref;

			if ( replyComment ) {
				const reply = {
					reply     : comment.text, // This is the new comment being written
					comment   : replyComment.text, // This is the comment being replied too
					createdAt : comment.createdAt,
					user      : comment.user,
					commentId : id,
					sectionId,
				};

				_firestore.collection( 'users' )
					.doc( replyComment.createdBy )
					.collection( 'replies' )
					.add( reply );
			}

			return id;
		} );

	return commentId;

};
